if (!customElements.get('wishlist-item')) {
  class WishlistItem extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.addEventListener(
        'change',
        debounce(this.onOptionChange.bind(this), 200)
      );
    }

    onOptionChange(event) {
      this.updateOptions(event);
      this.updateMasterId();
      this.toggleAddButton(true, '');

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.theme.strings.product.unavailable);
        this.setUnavailable();

        return;
      }

      this.updateVariantInput();
      this.updateImage();
      this.updateProductInfo();
    }

    updateOptions(event) {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (element) => element.value
      ).filter((option, index, array) => array.indexOf(option) === index);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find(
        (variant) =>
          !variant.options
            .map((option, index) => this.options[index] === option)
            .includes(false)
      );
    }

    updateVariantInput() {
      const input = this.querySelector('[name="id"]');
      input.value = this.currentVariant.id;
    }

    updateImage() {
      const image = this.getVariantsImages()[this.currentVariant.id];
      const productImage = this.querySelector('[data-primary-image]');

      if (!image) return;

      productImage.src = image.src;
      productImage.dataset.src = image.src;
      productImage.srcset = decodeURIComponent(image.srcset);
      productImage.dataset.srcset = decodeURIComponent(image.srcset);
      productImage.alt = image.alt;
    }

    toggleAddButton(disable = true, text) {
      const addButton = this.form.querySelector('[name="add"]');
      const addButtonText = this.form.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');

        if (text) {
          addButtonText.textContent = text;
          addButton.classList.remove('is-loading');
        } else {
          addButton.classList.add('is-loading');
        }
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.theme.strings.product.addToCart;
        addButton.classList.remove('is-loading');
      }
    }

    setUnavailable() {
      const addButton = this.form.querySelector('[name="add"]');
      const addButtonText = this.form.querySelector('[name="add"] > span');
      const price = this.querySelector('[data-price]');

      if (!addButton) return;

      addButtonText.textContent = window.theme.strings.product.unavailable;

      if (price) price.classList.add('visibility-hidden');
    }

    updateProductInfo() {
      const price = this.querySelector('[data-price]');
      price.innerHTML = decodeURIComponent(
        this.getVariantsPrices()[this.currentVariant.id]
      );
      price.classList.remove('visibility-hidden');
      this.toggleAddButton(
        !this.currentVariant.available,
        window.theme.strings.product.soldOut
      );
    }

    getVariantData() {
      return JSON.parse(this.querySelector('[data-product-json]').textContent)
        .variants;
    }

    getVariantsPrices() {
      return JSON.parse(
        this.querySelector('[data-variants-prices-json]').textContent
      );
    }

    getVariantsImages() {
      return JSON.parse(
        this.querySelector('[data-variants-images-json]').textContent
      );
    }
  }

  customElements.define('wishlist-item', WishlistItem);
}

class WishlistItemForm extends customElements.get('product-form') {
  constructor() {
    super();
    this.errorMessageWrapper = this.querySelector('[data-error-wrapper]');
    this.errorMessage = this.querySelector('[data-error]');
  }
}

customElements.define('wishlist-item-form', WishlistItemForm);
